export default __webpack_public_path__ + "static/media/07.8b3cba4e.jpg";